import API from '../api/api'

// ACTION TYPES
const GET_GLOSSARY_JWT_PENDING = 'GET_GLOSSARY_JWT_PENDING'
const GET_GLOSSARY_JWT_RESPONSE = 'GET_GLOSSARY_JWT_RESPONSE'
const GET_GLOSSARY_PENDING = 'GET_GLOSSARY_PENDING'
const GET_GLOSSARY_RESPONSE = 'GET_GLOSSARY_RESPONSE'
const CREATE_GLOSSARY_ENTRY_PENDING = 'CREATE_GLOSSARY_ENTRY_PENDING'
const CREATE_GLOSSARY_ENTRY_RESPONSE = 'CREATE_GLOSSARY_ENTRY_RESPONSE'
const CREATE_GLOSSARY_TRANSLATION_PENDING = 'CREATE_GLOSSARY_TRANSLATION_PENDING'
const CREATE_GLOSSARY_TRANSLATION_RESPONSE = 'CREATE_GLOSSARY_TRANSLATION_RESPONSE'
const DELETE_GLOSSARY_TRANSLATION_PENDING = 'DELETE_GLOSSARY_TRANSLATION_PENDING'
const DELETE_GLOSSARY_TRANSLATION_RESPONSE = 'DELETE_GLOSSARY_TRANSLATION_RESPONSE'
const UPDATE_GLOSSARY_ENTRY_PENDING = 'UPDATE_GLOSSARY_ENTRY_PENDING'
const UPDATE_GLOSSARY_ENTRY_RESPONSE = 'UPDATE_GLOSSARY_ENTRY_RESPONSE'
const DELETE_GLOSSARY_ENTRY_PENDING = 'DELETE_GLOSSARY_ENTRY_PENDING'
const DELETE_GLOSSARY_ENTRY_RESPONSE = 'DELETE_GLOSSARY_ENTRY_RESPONSE'
const EXPORT_GLOSSARY_PENDING = 'EXPORT_GLOSSARY_PENDING'
const EXPORT_GLOSSARY_RESPONSE = 'EXPORT_GLOSSARY_RESPONSE'
const IMPORT_GLOSSARY_PENDING = 'IMPORT_GLOSSARY_PENDING'
const IMPORT_GLOSSARY_RESPONSE = 'IMPORT_GLOSSARY_RESPONSE'
const RESET_ERRORS = 'RESET_ERRORS'

const initialState = {
  get_glossary_jwt_pending: false,
  get_glossary_pending: false,
  create_glossary_entry_pending: false,
  create_glossary_translation_pending: false,
  delete_glossary_translation_pending: false,
  update_glossary_entry_pending: false,
  delete_glossary_entry_pending: false,
  export_glossary_pending: false,
  import_glossary_pending: false,
  progress: 0,
  error: false,
  jwt: null,
  glossary_entries: [],
  overlimit: [],
  export_download_url: null,
  imported_entries: 0,
}

// REDUCER
export default (state = initialState, action) => {
  switch(action.type) {
    case RESET_ERRORS: {
      return {
        ...state,
        error: false,
      }
    }

    case GET_GLOSSARY_JWT_PENDING: {
      return {
        ...state,
        get_glossary_jwt_pending: true,
        error: false,
      }
    }
    case GET_GLOSSARY_JWT_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          get_glossary_jwt_pending: false,
          error: false,
          jwt: action.response.jwt,
        }
      } else {
        return {
          ...state,
          get_glossary_jwt_pending: false,
          error: {
            message: action.response?.message || action.response?.error || 'Failed to get JWT token',
            action: action.action,
            level: 0,
          },
        }
      }
    }

    case GET_GLOSSARY_PENDING: {
      return {
        ...state,
        get_glossary_pending: true,
        error: false,
      }
    }
    case GET_GLOSSARY_RESPONSE: {
      // If response has explicit success field and it's true
      if (action.response.success === true) {
        return {
          ...state,
          get_glossary_pending: false,
          error: false,
          glossary_entries: action.response.glossary || [],
          overlimit: action.response.overlimit || [],
        }
      }

      // If response has explicit success field and it's false
      if (action.response.success === false) {
        return {
          ...state,
          get_glossary_pending: false,
          error: {
            message: action.response?.message || action.response?.error || 'Failed to load glossary',
            action: action.action,
            level: 0,
          },
        }
      }
      
      // If response is empty object or has no recognizable structure
      return {
        ...state,
        get_glossary_pending: false,
        error: false,
        glossary_entries: [],
        overlimit: [],
      }
    }

    case CREATE_GLOSSARY_ENTRY_PENDING: {
      return {
        ...state,
        create_glossary_entry_pending: true,
        error: false,
      }
    }
    case CREATE_GLOSSARY_ENTRY_RESPONSE: {
      if(action.response.success === true && action.response.text) {
        return {
          ...state,
          create_glossary_entry_pending: false,
          error: false,
          glossary_entries: [...state.glossary_entries, action.response.text],
        }
      } else {
        return {
          ...state,
          create_glossary_entry_pending: false,
          error: {
            message: action.response?.message || action.response?.error || 'Failed to create glossary entry',
            action: action.action,
            level: 1,
          },
        }
      }
    }

    case UPDATE_GLOSSARY_ENTRY_PENDING: {
      return {
        ...state,
        update_glossary_entry_pending: true,
        error: false,
      }
    }
    case UPDATE_GLOSSARY_ENTRY_RESPONSE: {
      if(action.response.success === true && action.response.text) {
        const newEntries = state.glossary_entries.map(entry =>
          entry.id === action.entryId ? action.response.text : entry
        );
        return {
          ...state,
          update_glossary_entry_pending: false,
          error: false,
          glossary_entries: newEntries,
        }
      } else if(action.response.success === true && action.response.message) {
        return {
          ...state,
          update_glossary_entry_pending: false,
          error: false,
        }
      } else {
        return {
          ...state,
          update_glossary_entry_pending: false,
          error: {
            message: action.response?.message || action.response?.error || 'Failed to update glossary entry',
            action: action.action,
            level: 1,
          },
        }
      }
    }

    case DELETE_GLOSSARY_ENTRY_PENDING: {
      return {
        ...state,
        delete_glossary_entry_pending: true,
        error: false,
      }
    }
    case DELETE_GLOSSARY_ENTRY_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          delete_glossary_entry_pending: false,
          error: false,
          glossary_entries: action.response.glossary || state.glossary_entries,
          overlimit: action.response.overlimit || state.overlimit,
        }
      } else {
        return {
          ...state,
          delete_glossary_entry_pending: false,
          error: {
            message: action.response?.message || action.response?.error || 'Failed to delete glossary entry',
            action: action.action,
            level: 1,
          },
        }
      }
    }

    case CREATE_GLOSSARY_TRANSLATION_PENDING: {
      return {
        ...state,
        create_glossary_translation_pending: true,
        error: false,
      }
    }
    case CREATE_GLOSSARY_TRANSLATION_RESPONSE: {
      if(action.response.success === true) {
        let newEntries = state.glossary_entries.slice();
        let entryToUpdate = newEntries.find(x => x.id == action.response.glossary_text_id);

        if(entryToUpdate) {
          if(!entryToUpdate.translations) {
            entryToUpdate.translations = [];
          }
          entryToUpdate.translations.push(action.response.translation);
        }

        return {
          ...state,
          create_glossary_translation_pending: false,
          error: false,
          glossary_entries: newEntries,
        }
      } else {
        return {
          ...state,
          create_glossary_translation_pending: false,
          error: {
            message: action.response?.message || action.response?.error || 'Failed to create translation',
            action: action.action,
            level: 1,
          },
        }
      }
    }

    case DELETE_GLOSSARY_TRANSLATION_PENDING: {
      return {
        ...state,
        delete_glossary_translation_pending: true,
        error: false,
      }
    }
    case DELETE_GLOSSARY_TRANSLATION_RESPONSE: {
      if(action.response.success === true) {
        const newEntries = state.glossary_entries.map(entry => {
          if(entry.id === action.entryId && entry.language_id === action.languageId) {
            return {
              ...entry,
              target: ''
            };
          }
          return entry;
        });
        return {
          ...state,
          delete_glossary_translation_pending: false,
          error: false,
          glossary_entries: newEntries,
        }
      } else {
        return {
          ...state,
          delete_glossary_translation_pending: false,
          error: {
            message: action.response?.message || action.response?.error || 'Failed to delete translation',
            action: action.action,
            level: 1,
          },
        }
      }
    }

    case EXPORT_GLOSSARY_PENDING: {
      return {
        ...state,
        progress: 0,
        export_glossary_pending: true,
        export_download_url: null,
      }
    }
    case EXPORT_GLOSSARY_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          progress: 100,
          export_glossary_pending: false,
          export_download_url: action.response.download_url,
        }
      } else {
        return {
          ...state,
          progress: 100,
          export_glossary_pending: false,
          error: {
            message: action.response?.message || action.response?.error || 'Failed to export glossary',
            action: action.action,
          },
        }
      }
    }

    case IMPORT_GLOSSARY_PENDING: {
      return {
        ...state,
        progress: 0,
        import_glossary_pending: true,
        imported_entries: 0,
      }
    }
    case IMPORT_GLOSSARY_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          progress: 100,
          import_glossary_pending: false,
          imported_entries: action.response.imported_entries || 0,
        }
      } else {
        return {
          ...state,
          progress: 100,
          import_glossary_pending: false,
          error: {
            message: action.response?.message || action.response?.error || 'Failed to import glossary',
            action: action.action,
          },
        }
      }
    }

    default:
      return state
  }
}

// ACTIONS
export const resetErrors = () => {
  return dispatch => {
    dispatch({
      type: RESET_ERRORS
    });
  }
}

export const getGlossaryJWT = (callback) => {
  return dispatch => {
    dispatch({
      type: GET_GLOSSARY_JWT_PENDING
    })

    API.getGlossaryJWT(
      response => {
        dispatch({
          type: GET_GLOSSARY_JWT_RESPONSE,
          response: response,
          action: () => getGlossaryJWT(callback)
        });
        if(callback) {
          callback(response);
        }
      }
    )
  }
}

export const getGlossary = (languageId, callback) => {
  return dispatch => {
    dispatch({
      type: GET_GLOSSARY_PENDING
    })

    API.getGlossary(
      languageId,
      response => {
        dispatch({
          type: GET_GLOSSARY_RESPONSE,
          response: response,
          action: () => getGlossary(languageId, callback)
        });
        if(callback) {
          callback(response);
        }
      }
    )
  }
}

export const createGlossaryEntry = (source, type, target, languageId, callback) => {
  return dispatch => {
    dispatch({
      type: CREATE_GLOSSARY_ENTRY_PENDING
    })

    API.createGlossaryEntry(
      source,
      type,
      target,
      languageId,
      response => {
        dispatch({
          type: CREATE_GLOSSARY_ENTRY_RESPONSE,
          response: response,
          action: () => createGlossaryEntry(source, type, target, languageId, callback)
        });
        if(callback) {
          callback(response);
        }
      }
    )
  }
}

export const updateGlossaryEntry = (entryId, source, type, target, languageId, callback) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_GLOSSARY_ENTRY_PENDING
    })

    let languageCode;
    if (target === '') {
      const state = getState();
      languageCode = state.languages.languages.find(x => x.id == languageId).code;
    }

    API.updateGlossaryEntry(
      entryId,
      source,
      type,
      target,
      languageCode ? languageCode : languageId,
      response => {
        dispatch({
          type: UPDATE_GLOSSARY_ENTRY_RESPONSE,
          response: response,
          entryId: entryId,
          action: () => updateGlossaryEntry(entryId, source, type, target, languageId, callback)
        });
        if(callback) {
          callback(response);
        }
      }
    )
  }
}

// translate <-> block: the type alone. updateGlossaryEntry would read the blocked term's empty
// target as "delete the translation", which is not what a mode switch means
export const updateGlossaryEntryMode = (entryId, source, type, languageId, callback) => {
  return dispatch => {
    dispatch({
      type: UPDATE_GLOSSARY_ENTRY_PENDING
    })

    API.updateGlossaryEntryMode(
      entryId,
      source,
      type,
      languageId,
      response => {
        dispatch({
          type: UPDATE_GLOSSARY_ENTRY_RESPONSE,
          response: response,
          entryId: entryId,
          action: () => updateGlossaryEntryMode(entryId, source, type, languageId, callback)
        });
        if(callback) {
          callback(response);
        }
      }
    )
  }
}

export const deleteGlossaryEntry = (glossaryTextId, language, callback) => {
  return dispatch => {
    dispatch({
      type: DELETE_GLOSSARY_ENTRY_PENDING
    })

    API.deleteGlossaryEntry(
      glossaryTextId,
      language,
      response => {
        dispatch({
          type: DELETE_GLOSSARY_ENTRY_RESPONSE,
          response: response,
          action: () => deleteGlossaryEntry(glossaryTextId, language, callback)
        });
        if(callback) {
          callback(response);
        }
      }
    )
  }
}

export const createGlossaryTranslation = (glossaryTextId, language, translation, callback) => {
  return dispatch => {
    dispatch({
      type: CREATE_GLOSSARY_TRANSLATION_PENDING
    })

    API.createGlossaryTranslation(
      glossaryTextId,
      language,
      translation,
      response => {
        dispatch({
          type: CREATE_GLOSSARY_TRANSLATION_RESPONSE,
          response: response,
          action: () => createGlossaryTranslation(glossaryTextId, language, translation, callback)
        });
        if(callback) {
          callback(response);
        }
      }
    )
  }
}

export const deleteGlossaryTranslation = (entryId, languageId, callback) => {
  return (dispatch, getState) => {
    dispatch({
      type: DELETE_GLOSSARY_TRANSLATION_PENDING
    })

    // Convert language ID to language code
    const state = getState();
    const languageCode = state.languages.languages.find(x => x.id == languageId)?.code || languageId;

    API.deleteGlossaryTranslation(
      entryId,
      languageCode,
      response => {
        dispatch({
          type: DELETE_GLOSSARY_TRANSLATION_RESPONSE,
          response: response,
          entryId: entryId,
          languageId: languageId,
          languageCode: languageCode,
          action: () => deleteGlossaryTranslation(entryId, languageId, callback)
        });
        if(callback) {
          callback(response);
        }
      }
    )
  }
}

export const exportGlossary = (jwt, callback) => {
  return dispatch => {
    dispatch({
      type: EXPORT_GLOSSARY_PENDING
    })

    API.exportGlossary(
      jwt,
      response => {
        dispatch({
          type: EXPORT_GLOSSARY_RESPONSE,
          response: response,
          action: () => exportGlossary(jwt, callback)
        });
        if(callback) {
          callback(response);
        }
      }
    )
  }
}

export const importGlossary = (jwt, file, callback) => {
  return dispatch => {
    dispatch({
      type: IMPORT_GLOSSARY_PENDING
    })

    API.importGlossary(
      jwt,
      file,
      response => {
        dispatch({
          type: IMPORT_GLOSSARY_RESPONSE,
          response: response,
          action: () => importGlossary(jwt, file, callback)
        });
        if(callback) {
          callback(response);
        }
      }
    )
  }
}